import { Fragment, type ReactElement } from "react";
import styles from "./Highlight.module.css";

export interface HighlightProps {
  text: string;
  matches?: Set<number>;
}

export function Highlight({ text, matches }: HighlightProps): ReactElement {
  if (!matches || matches.size === 0) return <>{text}</>;

  const runs: { text: string; hit: boolean }[] = [];
  for (let i = 0; i < text.length; i += 1) {
    const hit = matches.has(i);
    const last = runs[runs.length - 1];
    if (last && last.hit === hit) last.text += text[i];
    else runs.push({ text: text[i], hit });
  }

  return (
    <>
      {runs.map((run, index) =>
        run.hit ? (
          <mark key={index} className={styles.mark}>
            {run.text}
          </mark>
        ) : (
          <Fragment key={index}>{run.text}</Fragment>
        ),
      )}
    </>
  );
}
